const KeenSlider = window.KeenSlider

const { breakpoints } = window.BAO.MediaBreakpoints
const { setInitialised, addWheelControls } = window.BAO.Carousel.plugins

class CompleteTheSet extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 3,
          spacing: 1,
        },
        breakpoints: {
          [`(min-width: ${breakpoints.sm}px)`]: {
            slides: {
              perView: 4,
              spacing: 1,
            },
          },
        },
      },
      [setInitialised(), addWheelControls('horizontal')],
    )
  }
}

if (!customElements.get('complete-the-set')) {
  customElements.define('complete-the-set', CompleteTheSet)
}
